module.exports = __webpack_public_path__ + "img/1557614078821736449.5e76ea58.png";